import {
  AiOutlineCalendar,
  AiOutlineDashboard,
  AiOutlineProduct,
  AiOutlineSetting,
} from "react-icons/ai";
import { LuChevronLeft, LuChevronRight } from "react-icons/lu";
import HomeLink from "../components/HomeLink";
import { useContext, useEffect } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { handleFetchSites } from "../apis/sites";
import Moment from "react-moment";
import logo from "../assets/images/small.png";
import { MdCheck } from "react-icons/md";
import { Popover } from "antd";
import { GoChevronDown } from "react-icons/go";
import Profile from "./Profile";

export default function Header() {
  const date = new Date();

  const { updateSite, site } = useContext(AuthContext);

  const { data } = useQuery({
    queryKey: ["sites"],
    queryFn: handleFetchSites,
  });

  const handleSelectSite = (site: any) => {
    if (site === 0) {
      updateSite({ _id: "", name: "All Branches", branch: "" });
    } else {
      const selected = data?.records.find((s: any) => s?._id === site);
      updateSite(selected);
    }
  };

  const menus = [
    {
      id: 1,
      isActive: true,
      to: "/dashboard",
      name: "Summary",
      icon: <AiOutlineDashboard size={18} />,
    },
    {
      id: 2,
      isActive: false,
      to: "/bookings",
      name: "Bookings",
      icon: <AiOutlineProduct size={18} />,
    },
    {
      id: 3,
      isActive: false,
      to: "/calendar",
      name: "Calendar",
      icon: <AiOutlineCalendar size={18} />,
    },
    {
      id: 4,
      isActive: false,
      to: "/manage",
      name: "Manage",
      icon: <AiOutlineSetting size={18} />,
    },
  ];

  const sites = (
    <div>
      {data?.records?.map((item: any, index: number) => (
        <button
          onClick={() => handleSelectSite(item?._id)}
          key={index}
          className="border-t py-1 hover:bg-gray-100 cursor-pointer w-full flex justify-between"
        >
          <div className="">{item?.name}</div>
          <div
            className={`w-6 h-6 flex justify-center items-center border border-gray-400 ${item?._id === site?._id
              ? "bg-green-500"
              : site?._id === ""
                ? "bg-green-500"
                : ""
              }`}
          >
            {item?._id === site?._id ? (
              <MdCheck color="#FFFFFF" />
            ) : site?._id === "" ? (
              <MdCheck color="#FFFFFF" />
            ) : null}
          </div>
        </button>
      ))}

      <button
        onClick={() => handleSelectSite(0)}
        className="border-t-4 py-1 hover:bg-gray-100 cursor-pointer w-full flex justify-between"
      >
        <div className="">All Branches</div>
        <div
          className={`w-6 h-6 flex justify-center items-center border border-gray-400 ${site?._id === "" ? "bg-green-500" : ""
            }`}
        >
          {site?._id === "" ? <MdCheck color="#FFFFFF" /> : null}
        </div>
      </button>
    </div>
  );

  useEffect(() => { }, [site]);
  return (
    <div className="">

      <div className="bg-auto-blue-dark flex justify-between items-center px-4">
        <div className="w-1/3 flex items-center gap-x-4">
          <img src={logo} alt="" width={35} />

          <div className="flex flex-col border-l px-2 gap-x-4">
            <Popover placement="bottom" title={"Select Branch"} content={sites}>
              <div className="flex items-center cursor-pointer">
                <div className="text-white  hidden md:block uppercase text-lg font-extrabold">
                  {site ? (
                    <div className="">{site?.name}</div>
                  ) : (
                    <div className="">Branch</div>
                  )}
                </div>
                <div className="">
                  <GoChevronDown color="#FFFFFF" size={34} />
                </div>
              </div>
            </Popover>
            <div className="text-white text-auto-xs -mt-2">TANZANIA 🇹🇿</div>
          </div>
        </div>

        <div className="w-1/3 flex flex-col justify-center items-center">
          <div className="flex justify-between py-3">
            <div className="flex justify-between items-center text-white mx-8  flex-1 rounded-lg" style={{ backgroundColor: "#27426d" }}>
              <button className="flex justify-center items-center w-20 hover:bg-blue-600 py-3 rounded-l-lg">
                <LuChevronLeft />
              </button>
              <div className="flex flex-col items-center w-full sm:w-80">
                <div className="font-bold">TODAY</div>
                <div className="-mt-1 uppercase text-auto-xxs">
                  <Moment format="DD MMMM YYYY">{date}</Moment>
                </div>
              </div>
              <div className="flex justify-center items-center w-20 hover:bg-blue-600 py-2 rounded-r-lg">
                <LuChevronRight />
              </div>
            </div>
          </div>

        </div>
        <div className="w-1/3 flex justify-end">
          <div className="flex flex-row items-center">
            <div className="text-white font-bold bg-green-100"></div>
            <div className="ml-2 mr-4 z-50">
              <Profile />
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center bg-auto-gray-pale">

        <div className="flex py-2 font-bold">
          {menus.map((menu: any, index: number) => (
            <HomeLink menu={menu} key={index}>
              {menu.name}
            </HomeLink>
          ))}
        </div>
      </div>
    </div>
  );
}
